export const WECHAT_CONFIG_EVENT = 'tezzolo-wechat-config';

const STATE_KEY = '__TEZZOLO_WECHAT_CONFIG_STATE__';

const idleState = { status: 'idle' };

export const getWechatConfigState = () => {
  if (typeof window === 'undefined') return idleState;
  return window[STATE_KEY] || idleState;
};

export const publishWechatConfigState = (status, detail = {}) => {
  if (typeof window === 'undefined') return { status, ...detail };

  const state = {
    status,
    ...detail,
    updatedAt: Date.now(),
  };
  window[STATE_KEY] = state;

  let event;
  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(WECHAT_CONFIG_EVENT, { detail: state });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(WECHAT_CONFIG_EVENT, false, false, state);
  }
  window.dispatchEvent(event);
  return state;
};
